import { render, staticRenderFns } from "./car-section.vue?vue&type=template&id=dcddfcca&scoped=true"
import script from "./car-section.vue?vue&type=script&lang=js"
export * from "./car-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcddfcca",
  null
  
)

export default component.exports